export default __webpack_public_path__ + "static/media/Speer_Showreel.daabab3f.mp4";